angular.module('billing').controller('LedgerModalCtrl',
    ['$scope', '$uibModalInstance', '$sce', '$window', 'BillingRepository', 'loginUser',
        function ($scope, $modalInstance, $sce, $window, BillingRepository, loginUser) {
            'use strict';

            $scope.loadingLedger = true;
            $scope.model = {
                LedgerData: '',
                PdfFileName: loginUser.fullName + '_Ledger.pdf',
                Base64: '',
                ContentType: ''
            };

            function loadLedger() {
                BillingRepository.getLedgerUrl(loginUser.id)
                    .then(function (data) {
                        if (data) {
                            var ledgerPdf = 'data:' + data.ContentType + ';base64,' + data.ByteArray;
                            $scope.model.LedgerData = $sce.trustAsResourceUrl(ledgerPdf);
                            $scope.model.ByteArray = data.ByteArray;
                            $scope.model.ContentType = data.ContentType;
                        }
                    })
                    .finally(function () {
                        $scope.loadingLedger = false;
                    });
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            function print() {
                $window.print();
            }

            $scope.print = print;
            $scope.ok = ok;
            $scope.cancel = cancel;

            loadLedger();
        }]);
